// Otimização de imagens do catálogo e da vitrine.
// 1) Storage do backend: troca a URL "object" pelo endpoint de transformação
//    "render/image", que entrega redimensionado e em WebP quando o browser suporta.
// 2) Imagens locais em /images/**: apontam para o .webp equivalente gerado no build
//    (todos os .jpg/.jpeg/.png dessa pasta têm um par .webp versionado).
// URLs externas são devolvidas sem alteração.

const OBJECT_PATH = "/storage/v1/object/public/";
const RENDER_PATH = "/storage/v1/render/image/public/";
const LOCAL_IMAGES_PREFIX = "/images/";

export function optimizedImage(url: string | null | undefined, width = 600, quality = 70): string {
  const src = String(url ?? "").trim();
  if (!src) return "";
  if (/\.svg($|\?)/i.test(src)) return src;

  // Imagens locais servidas pelo próprio site: usa a versão WebP.
  if (src.startsWith(LOCAL_IMAGES_PREFIX)) {
    return src.replace(/\.(jpe?g|png)($|\?)/i, ".webp$2");
  }

  if (!src.includes(OBJECT_PATH)) return src;

  const [base, query] = src.split("?");
  const rendered = base.replace(OBJECT_PATH, RENDER_PATH);
  const params = new URLSearchParams(query);
  params.set("width", String(width));
  params.set("quality", String(quality));
  params.set("resize", "contain");
  return `${rendered}?${params.toString()}`;
}


/** Atalhos por contexto de uso, para manter larguras consistentes no site. */
export const imgThumb = (u?: string | null) => optimizedImage(u, 160, 65);
export const imgCard = (u?: string | null) => optimizedImage(u, 500, 70);
export const imgDetail = (u?: string | null) => optimizedImage(u, 1000, 75);
